/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 1:02:40 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import { User } from "lib/schemas";
import { SuccessCheckButton, ErrorXButton, EditToggler } from "ui-widgets";
import { TextFormInput } from "ui-widgets/forms";

interface UserAccountInformationProps {
  user: User;
  editModeCondition: boolean;
}

export const UserAccountInformation = ({ user, editModeCondition }: UserAccountInformationProps) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <div className="os-profile-field-label">Username</div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className="os-profile-field-value">{user.username}</div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div className="os-profile-field-label">Primary Email</div>
        </Grid>
        <Grid item xs={12} md={6}>
          <EditToggler
            editModeCondition={editModeCondition}
            renderEditComponent={({ setValueInputRef }) => (
              <TextFormInput<User> inputRef={setValueInputRef} schema_field_key="email" />
            )}
          >
            {({ editIcon }) => (
              <>
                <a className="os-profile-field-value" href={`mailto:${user.email}`}>
                  {user.email}
                </a>
                {editIcon}
              </>
            )}
          </EditToggler>
        </Grid>

        <Grid item xs={12} md={6}>
          <div className="os-profile-field-label">Status</div>
        </Grid>
        <Grid item xs={12} md={6}>
          {user.is_active ? (
            <div className="os-user-status-indicator active">
              <SuccessCheckButton> Active</SuccessCheckButton>
            </div>
          ) : (
            <div className="os-user-status-indicator inactive">
              <ErrorXButton>Inactive</ErrorXButton>
            </div>
          )}
        </Grid>
      </Grid>
    </>
  );
};
